import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServerURLService {

  apiAddress: any;
  apiServerAddress: any;
  DocumentServerAddress: any;
  ptrDocument: any;
  viewDocumentsPath: any;
  notesheetView: any;
  nocPath: any;
  noteSheetViewTrackSecExe: any;
  noteSheetViewTrackSecInc: any;
  noteSheetViewDispatch: any;
  noteSheetViewOtherSection: any;
  secretKey: any;
  agendaViewOtherModule: any;
  fqsrReferenceView: any;
  eligibilityReferenceView: any;

  constructor() {
    this.secretKey = 7061737323313233;
    if (window.location.hostname === 'localhost') {
      //Local
       this.apiAddress = 'http://localhost';
      //  this.apiAddress = 'http://36.255.253.200';

      //Dev Server      
    // this.apiAddress = 'http://103.210.72.123';
            
      this.apiServerAddress = this.apiAddress + ':8080/';
      this.nocPath = this.apiAddress + ':8083';
      this.ptrDocument = this.nocPath + '/pdfPath/ptrDocuments';
      this.notesheetView = this.apiAddress + ':4200/main/internal/outbound/se/createNoteSheet/0';
      this.noteSheetViewTrackSecExe = this.apiAddress + ':4200/main/internal/outbound/se/viewTracksheetSecExec/';
      this.noteSheetViewTrackSecInc = this.apiAddress + ':4200/main/internal/outbound/secInch/viewTrackSheet/';
      this.noteSheetViewDispatch = this.apiAddress + ':4200/main/internal/outbound/se/viewDispatch/';
      this.noteSheetViewOtherSection = this.apiAddress + ':4200/main/internal/outbound/viewDispatch/otherSection/';

      this.agendaViewOtherModule = this.apiAddress + ':4200/main/internal/excu/viewAgenda/';
      this.fqsrReferenceView = this.apiAddress + ':4200/main/internal/fqsr/referenceView/';
      this.eligibilityReferenceView = this.apiAddress + ':4200/main/internal/eligibility/referenceView/';

      this.DocumentServerAddress = 'http://okmAdmin:admin@103.210.72.67/';
    } else if (window.location.hostname === '103.210.72.123') {
      //Dev Server
      this.apiAddress = 'http://103.210.72.123';
      this.apiServerAddress = this.apiAddress + ':8080/';
      this.nocPath = this.apiAddress + ':9080';
      this.ptrDocument = this.nocPath + '/pdfPath/ptrDocuments';
      this.notesheetView = this.apiAddress + '/main/internal/outbound/se/createNoteSheet/0';
      this.noteSheetViewOtherSection = this.apiAddress + '/main/internal/outbound/viewDispatch/otherSection/';      
      this.noteSheetViewTrackSecExe = this.apiAddress + '/main/internal/outbound/se/viewTracksheetSecExec/';
      this.noteSheetViewTrackSecInc = this.apiAddress + '/main/internal/outbound/secInch/viewTrackSheet/';
      this.noteSheetViewDispatch = this.apiAddress + '/main/internal/outbound/se/viewDispatch/';

      this.agendaViewOtherModule = this.apiAddress + '/main/internal/excu/viewAgenda/';
      this.fqsrReferenceView = this.apiAddress + '/main/internal/fqsr/referenceView/';
      this.eligibilityReferenceView = this.apiAddress + '/main/internal/eligibility/referenceView/';

      this.DocumentServerAddress = 'http://okmAdmin:admin@103.210.72.67/';
    } 
    else if (window.location.hostname === '36.255.253.200') {
      //UAT Server
      this.apiAddress = 'http://36.255.253.200';
      this.apiServerAddress = this.apiAddress + ':8080/';
      this.nocPath = this.apiAddress + ':9080';
      this.ptrDocument = this.nocPath + '/pdfPath/ptrDocuments';
      this.notesheetView = this.apiAddress + '/main/internal/outbound/se/createNoteSheet/0';
      this.noteSheetViewOtherSection = this.apiAddress + '/main/internal/outbound/viewDispatch/otherSection/';
      this.noteSheetViewTrackSecExe = this.apiAddress + '/main/internal/outbound/se/viewTracksheetSecExec/';
      this.noteSheetViewTrackSecInc = this.apiAddress + '/main/internal/outbound/secInch/viewTrackSheet/';
      this.noteSheetViewDispatch = this.apiAddress + '/main/internal/outbound/se/viewDispatch/';

      this.agendaViewOtherModule = this.apiAddress + '/main/internal/excu/viewAgenda/';
      this.fqsrReferenceView = this.apiAddress + '/main/internal/fqsr/referenceView/';
      this.eligibilityReferenceView = this.apiAddress + '/main/internal/eligibility/referenceView/';

      this.DocumentServerAddress = 'http://okmAdmin:admin@103.210.74.169/';
    }
    else if (window.location.hostname === 'portal.dciindia.gov.in') {
      //Production
      this.apiServerAddress = 'https://portal.dciindia.gov.in/';
      this.apiAddress = this.apiServerAddress;
      this.nocPath = this.apiAddress + '/NOC';
      this.ptrDocument = this.nocPath + '/pdfPath/ptrDocuments';
      this.notesheetView = this.apiAddress + '/main/internal/outbound/se/createNoteSheet/0';
      this.noteSheetViewOtherSection = this.apiAddress + '/main/internal/outbound/viewDispatch/otherSection/';
      this.noteSheetViewTrackSecExe = this.apiAddress + '/main/internal/outbound/se/viewTracksheetSecExec/';
      this.noteSheetViewTrackSecInc = this.apiAddress + '/main/internal/outbound/secInch/viewTrackSheet/';
      this.noteSheetViewDispatch = this.apiAddress + '/main/internal/outbound/se/viewDispatch/';
      
      this.agendaViewOtherModule = this.apiAddress + '/main/internal/excu/viewAgenda/';
      this.fqsrReferenceView = this.apiAddress + '/main/internal/fqsr/referenceView/';
      this.eligibilityReferenceView = this.apiAddress + '/main/internal/eligibility/referenceView/';

      // this.DocumentServerAddress = 'http://okmAdmin:admin@103.210.74.169/';
      this.DocumentServerAddress = 'https://okmAdmin:admin@portal.dciindia.gov.in/';
    }  else if (window.location.hostname === '103.210.74.89') {
      //Staging Server
      this.apiAddress = 'http://103.210.74.89';
      this.apiServerAddress = this.apiAddress + ':80/';
      this.nocPath = this.apiAddress + ':9080';
      this.ptrDocument = this.nocPath + '/pdfPath/ptrDocuments';
      this.notesheetView = this.apiAddress + '/main/internal/outbound/se/createNoteSheet/0';
      this.noteSheetViewOtherSection = this.apiAddress + '/main/internal/outbound/viewDispatch/otherSection/';
      this.noteSheetViewTrackSecExe = this.apiAddress + '/main/internal/outbound/se/viewTracksheetSecExec/';
      this.noteSheetViewTrackSecInc = this.apiAddress + '/main/internal/outbound/secInch/viewTrackSheet/';
      this.noteSheetViewDispatch = this.apiAddress + '/main/internal/outbound/se/viewDispatch/';

      this.agendaViewOtherModule = this.apiAddress + '/main/internal/excu/viewAgenda/';
      this.fqsrReferenceView = this.apiAddress + '/main/internal/fqsr/referenceView/';
      this.eligibilityReferenceView = this.apiAddress + '/main/internal/eligibility/referenceView/';

      this.DocumentServerAddress = 'http://okmAdmin:admin@103.210.74.169/';
    }

  }
}
export const VARIABLE_SERVICE_PROVIDER = [
  ServerURLService
];
